<div class="page">
  <div class="content">
    <div class="content-header">
      <div class="title-primary" *ngIf="isCreateAccount && newPatient" >{{'CrtAccNewPatientPrimaryTitle' | cpLoginTranslate | async}}</div>
      <div class="title-secondary" *ngIf="isCreateAccount && newPatient && isUserNameReadOnly" >{{'CrtAccNewPatUserNameFilledSecTitle' | cpLoginTranslate | async}}</div>
      <div class="title-secondary" *ngIf="isCreateAccount && newPatient && !isUserNameReadOnly" >{{'CrtAccNewPatUserNameNotFilledSecTitle' | cpLoginTranslate | async}}</div>
      <div class="title-primary" *ngIf="isCreateAccount && !newPatient" >{{'CrtAccExistPatientPrimaryTitle' | cpLoginTranslate | async}}</div>
      <div class="title-secondary" *ngIf="isCreateAccount && !newPatient && isUserNameReadOnly" >{{'CrtAccExistPatUserNameFilledSecTitle' | cpLoginTranslate | async}}</div>
      <div class="title-secondary" *ngIf="isCreateAccount && !newPatient && !isUserNameReadOnly" >{{'CrtAccExistPatUserNameNotFilledSecTitle' | cpLoginTranslate | async}}</div>
      <div class="title-primary" *ngIf="isChangePassword " >{{'ChangePasswordPrimaryTitle' | cpLoginTranslate | async}}</div>
      <div class="title-secondary" *ngIf="isChangePassword " >{{'ChangePasswordSecondaryTitle' | cpLoginTranslate | async}}</div>
    </div>
    <form class="form-container" [formGroup]="formControls" autocomplete="off" action="">
      <div class="label-wrapper">
        <label>{{'UserName' | cpLoginTranslate | async}}:</label>
      </div>
      <div class="input-wrapper">
        <input autofocus type="text" [(ngModel)]="userName" formControlName="userName" [readonly]="isUserNameReadOnly" [ngClass]="{'disabled':isUserNameReadOnly}"
               autocomplete="off" autocorrect="off" autocapitalize="off" maxlength="50" (keypress)="resetErrors()"/>
        <label *ngIf="formControls.controls['userName'].touched && formControls.controls['userName'].hasError('required')" class="text-invalid">
          {{'UserNameRequired' | cpLoginTranslate | async}}
        </label>
        <label *ngIf="isUserNameInUse" class="text-invalid">
          {{'UserNameAlreadyInUse' | cpLoginTranslate | async}}
        </label>
      </div>
      <app-set-password #PasswordForm></app-set-password>
    </form>
  </div>
  <div class="buttons-wrapper" *ngIf="isCreateAccount">
    <cp-button class="primary-button call-to-action" captionToTranslate="CreateMyAccount.Login.PP" [disabled]="inProgress" (onClick)="createAccount()"></cp-button>
  </div>
  <div class="buttons-wrapper" *ngIf="isChangePassword">
    <cp-button class="primary-button call-to-action" captionToTranslate="ChangePassword.Login.PP" [disabled]="inProgress" (onClick)="changePassword()"></cp-button>
  </div>

  <div [ngClass]="inProgress ? 'overlay' : ''">
  </div>
  <div *ngIf="inProgress" class="progress-spinner">
    <div class="loading-image"></div>
  </div>
  </div>
